import { Scrollbars } from 'react-custom-scrollbars';

type Props = {
    children: React.ReactNode;
    className?: string;
    maxHeight: number;
};

export const ScrollBar = ({ children, className = '', maxHeight = 600 }: Props) => (
    <Scrollbars
        autoHeight
        autoHeightMax={maxHeight}
        hideTracksWhenNotNeeded
        renderView={(props) => (
            <div
                {...props}
                className={className}
            />
        )}
        universal
    >
        {children}
    </Scrollbars>
);
